import { Routes, Route, useNavigate, useParams, useSearchParams, Outlet, useOutletContext } from 'react-router-dom'
import { toast } from 'react-toastify'
import React from 'react'
import Container from '@mui/material/Container'
import Divider from '@mui/material/Divider'
import Box from '@mui/material/Box'
import { useQuery } from '~/client/hooks/cqrpc'

import ConnectionDetailsForm from '~/client/components/ConnectionDetailsForm'
import SideNote from '~/client/components/SideNote'
import Loading from '~/client/components/Loading'
import CreateAppAccount from '~/client/components/CreateAppAccount'
import AppAccountsList from '~/client/components/AppAccountsList'

export default function Page() {
  const { host } = useOutletContext()
  const appQuery = useQuery('apps.getByHost', { host })
  const appAccountsQuery = useQuery('appAccounts.getForHost', { host })
  if (appQuery.loading || appAccountsQuery.loading) return <Loading/>
  const app = appQuery.result
  const appAccounts = appAccountsQuery.result

  return <>
    <Container>
      <SideNote>{app.description}</SideNote>

      <Divider />
      <Box sx={{my: 2}}>
        {appAccounts.length === 0
          ? <CreateAppAccount {...{app, onSuccess: appAccountsQuery.reload,}}/>
          : <AppAccountsList {...{ appAccounts }}/>
        }
      </Box>

      <Divider />
      <Box sx={{ borderBottom: 1, my: 2, borderColor: 'divider'}}>
        <ConnectionDetailsForm {...{host}}/>
      </Box>
    </Container>
  </>
}

function AppAccount({ app, appAccount }){
  return <Box>
    {/* <InspectObject object={{ app, appAccount }}/> */}
  </Box>
}